import type { ChangeBrief, EvidencePacket } from "../../shared/schema";
import { CheckIcon, CloseIcon, FileIcon } from "../icons";

interface PacketDialogProps {
  change: ChangeBrief;
  packet: EvidencePacket | null;
  isOpen: boolean;
  onClose: () => void;
}

export function PacketDialog({ change, packet, isOpen, onClose }: PacketDialogProps) {
  if (!isOpen || !packet) return null;

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.currentTarget === event.target) onClose(); }}>
      <section className="modal packet-modal" role="dialog" aria-modal="true" aria-labelledby="packet-title">
        <header>
          <div><h2 id="packet-title">Review packet</h2><p>Human review is still required before any schema change is executed.</p></div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Close packet"><CloseIcon /></button>
        </header>
        <div className="packet-summary">
          <div className="decision-stamp"><CheckIcon /><span>Owner response</span><strong>Approve with conditions</strong></div>
          <div><span className="modal-label">CHANGE</span><h3>{change.sourceField} → {change.targetField}</h3><p>{packet.ownerSummary}</p></div>
        </div>
        <div className="packet-columns">
          <section><h3>Conditions</h3><ul>{packet.conditions.map((condition) => <li key={condition}>{condition}</li>)}</ul></section>
          <section><h3>Evidence</h3>{packet.answers.map((answer) => <div className="answer-row" key={answer.questionId}><FileIcon /><div><strong>{answer.answer}</strong><p>{answer.evidence}</p></div></div>)}</section>
        </div>
        <footer><span>Source: dry run · Call ID: none</span><button type="button" onClick={onClose}>Return to workspace</button></footer>
      </section>
    </div>
  );
}
